<div
  class="vtab-bottom-bar-wrapper"
  [ngClass]="{
    'justify-end': buttonPosition === 'end',
    'justify-center': buttonPosition === 'center',
    'justify-between': buttonPosition === 'between',
    'justify-start': buttonPosition === 'start',
  }">
  <vtab-action-bar class="w-full sticky bottom-0">
    @if (showSaveButton) {
      <cipx-primary-button [disabled]="!enableSaveButton" (buttonClick)="onSave()" [icon]="saveIcon">
        {{ saveText }}
      </cipx-primary-button>
    }

    @if (showCancelButton) {
      <cipx-cancel-button [disabled]="!enableCancelButton" (buttonClick)="onCancel()" [icon]="cancelIcon">
        {{ cancelText }}
      </cipx-cancel-button>
    }

    <ng-content></ng-content>
  </vtab-action-bar>
</div>
